import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=164fbdea&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=164fbdea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164fbdea",
  null
  
)

export default component.exports